<signup-verify-form
  (resendOtp)="resend()"
  (verify)="verify($event)"
  [isVerified]="isVerified"
  [errorCode]="errorCode"
  [appName]="appName"
></signup-verify-form>